import { SelectOption } from 'modules/queryBuilder/contexts';
import { MatchesCatalogComparator } from '../../../../types';
import { useTranslation } from '../../../../hooks';

export const useDisableCatalogOption = (value: string | null) => {
  const { t } = useTranslation();
  return (option: SelectOption<string>) => {
    return value === MatchesCatalogComparator.MATCHES_CATALOG_DATA ||
      option.value !== MatchesCatalogComparator.MATCHES_CATALOG_DATA
      ? option
      : {
          ...option,
          isDisabled: true,
          tooltipContent: t('catalogInSegmentation.disabledOptionTooltip'),
        };
  };
};
